import { Injectable } from '@angular/core';
import { ApiService } from '@us/web/shared/data-access';
import { roundToNearestMinute } from '@us/web/shared/utils';
import { DeviceDetectorService } from 'ngx-device-detector';
import { map, Observable } from 'rxjs';
import { NotificationM, NotificationsResponse } from '../models';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {
    private readonly url = 'notifications';
    private readonly maskAsReadUrl = 'notifications/read';
    private readonly pushNotificationUrl = 'push-notification';

    constructor(private apiService: ApiService, private deviceService: DeviceDetectorService) {}

    getNotifications({ cursor }: { cursor?: string | null } = { cursor: null }): Observable<NotificationsResponse> {
        return this.apiService
            .get(this.url, {
                params: {
                    ...(cursor ? {} : { t: roundToNearestMinute().getTime() }),
                    cursor: cursor || null
                }
            })
            .pipe(
                map(response => {
                    return {
                        ...response,
                        data: response.data.map((item: NotificationM) => ({
                            ...item,
                            created_at: item.created_at,
                            updated_at: item.updated_at
                        }))
                    };
                })
            );
    }

    getNotification(id: number, mask_as_read = false): Observable<NotificationM> {
        return this.apiService
            .get(`${this.url}/${id}`, {
                params: { mask_as_read }
            })
            .pipe(
                map(response => ({
                    ...response,
                    created_at: new Date(response.created_at),
                    updated_at: new Date(response.updated_at)
                }))
            );
    }

    markNotificationAsRead(id: number): Observable<NotificationM> {
        return this.apiService.post(this.maskAsReadUrl, { id });
    }

    registerPushNotification(token: string, accountId: number | string) {
        const params = {
            token,
            account_id: accountId,
            details: this.deviceService.getDeviceInfo()
        };

        return this.apiService.post(this.pushNotificationUrl, params);
    }
}
